import { createI18n } from 'vue-i18n/dist/vue-i18n.esm-bundler.js'
import store from '../store'
import locales_json from '../assets/locales.json'
import LabelService from '@/service/LabelService';
const labelService = new LabelService();

function stringToObj(path, value, obj) {
    var parts = path.split("."), part;
    var last = parts.pop();
    // eslint-disable-next-line no-cond-assign
    while (part = parts.shift()) {
        if (typeof obj[part] != "object") obj[part] = {};
        obj = obj[part]; // update "pointer"
    }
    obj[last] = value;
}

let locale = store.getters["preferences/locale"];
let languages = locales_json;

const messages = {};
if (languages) {
  languages.forEach((param) => {
    messages[param.code] = {}
  });
}
export const i18n = createI18n({
  locale: locale ? locale : 'it',
  messages,
  silentTranslationWarn: true
});

const loadedLanguages = []

function setI18nLanguage(lang) {
  i18n.locale = lang
  return lang
}

export async function loadLanguageAsync(lang) {
  if (typeof lang === 'undefined') {
    lang = window.navigator.userLanguage || window.navigator.language;
    lang = lang.slice(0, 2);
  }
  if (loadedLanguages.includes(lang)) {
    i18n.locale = lang;
    return Promise.resolve(setI18nLanguage(lang))
  }
  return labelService.getLabels(lang)
    .then(response => {
      let formattedLabels = {};
      response.forEach((param) => {
          stringToObj(param.attributes.key, param.attributes.value, formattedLabels );
      });
      loadedLanguages.push(lang);
      const old = i18n.global.getLocaleMessage(lang);
      i18n.global.setLocaleMessage(lang, { ...old, ...formattedLabels })
      return setI18nLanguage(lang)
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}
loadLanguageAsync(store.getters["preferences/locale"])

